"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const testimonials = [{
  quote: "En tant que jeune maman, je n’aurais jamais imaginé à quel point la présence d’Isa serait précieuse après la naissance de notre fils. Elle a apporté calme, soutien et douceur dans ces premières semaines à la fois magnifiques et bouleversantes. Grâce à son aide concrète — repas, maison, présence rassurante — j’ai pu me reposer, récupérer et créer du lien avec mon bébé. Je recommande Isa de tout cœur, surtout aux mamans qui vivent leur premier post-partum.",
  author: "Beren, maman du bébé A.",
  initials: "BA",
  featured: true
}, {
  quote: "Un immense merci à Isa pour ces précieux moments de douceur. Ce qu’elle offre est un cadeau inestimable : du temps. Grâce à elle, j’ai pu ralentir, me reposer et profiter pleinement des premières semaines avec mon nouveau-né. Son accompagnement a rendu cette période plus douce, plus sereine et profondément précieuse.",
  author: "Sophie, maman de deux enfants",
  initials: "SC",
  featured: false
}];
export default function Testimonials() {
  return <section className="bg-[#F8F4ED] py-14 md:py-16 px-4 md:px-8 overflow-hidden" id="testimonials">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="text-[0.75rem] font-semibold tracking-[0.2em] uppercase text-[#A77B62] font-sans">
              Témoignages
            </span>
            <div className="w-10 h-px bg-[#A77B62]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#43362F] mb-6 leading-tight">
            Elles racontent leur <span className="tracking-wider">expérience</span>
          </h2>
          <p className="font-sans text-lg md:text-xl text-[#43362F]/80 max-w-2xl mx-auto font-light leading-relaxed">
            Les mots de mamans que j'ai eu le privilège d'accompagner durant leur post-partum.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-stretch mb-12">
          {testimonials.map((item, i) => <div key={i} data-index={i} className={`group relative bg-[#FCFAF7] p-8 md:p-12 rounded-lg border border-[#D5C3B1]/30 transition-all duration-500 hover:border-[#A77B62]/40 flex flex-col justify-between ${item.featured ? "md:flex-[1.2] shadow-md" : "md:flex-1 shadow-sm"}`}>
              <div className="absolute top-8 right-8 text-[#C8735B]/10 group-hover:text-[#C8735B]/20 transition-colors duration-500">
                <Quote size={64} strokeWidth={1} />
              </div>

              <div className="relative z-10">
                <p className="font-sans text-[#43362F] text-lg md:text-xl leading-relaxed font-light mb-10 italic">
                  « {item.quote} »
                </p>
              </div>

              <div className="flex items-center gap-4 mt-auto">
                <SafeHydrate><Avatar className="size-12 border border-[#D5C3B1] bg-[#EFE6DC]">
                  <AvatarFallback className="font-sans text-[#43362F] font-medium text-sm">
                    {item.initials}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <div>
                  <p className="font-sans font-semibold text-[#43362F] text-sm tracking-wide">
                    {item.author}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center pt-8 border-t border-[#D5C3B1]/30">
          <h3 className="font-serif text-2xl md:text-3xl text-[#43362F] mb-8">
            À ton tour de vivre un post-partum soutenu et serein.
          </h3>
          <Button asChild className="rounded-lg bg-[#A77B62] hover:bg-[#43362F] text-[#FCFAF7] px-10 py-7 h-auto text-lg font-sans tracking-wide transition-all duration-400 shadow-md">
            <Link to="/ContactPage">Réserver un appel découverte</Link>
          </Button>
        </div>
      </div>
    </section>;
}